import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

export interface EmailDomainAuthConfigService {
    all: boolean;
    allowedEmailsDomains: string[];
}

@Injectable({
    providedIn: 'root',
})
export class EmailDomainAuthService {
    private baseUrl = `${environment.url}api/v1/pressroom/emaildomainauth`;

    constructor(private http: HttpClient) {}

    getConfig(pressroomId: string): Observable<EmailDomainAuthConfigService> {
        return this.http.get<EmailDomainAuthConfigService>(
            `${this.baseUrl}/${pressroomId}`,
        );
    }

    updateConfig(
        pressroomId: string,
        payload: EmailDomainAuthConfigService,
    ): Observable<any> {
        return this.http.put(`${this.baseUrl}/${pressroomId}`, payload);
    }
}
